// Constants for the application
export const TWITTER_PROFILE_URL = 'https://x.com/0xfab_eth';

// You can add more constants here as needed
